module.exports = __webpack_public_path__ + "static/media/coffee-cup.ca519395.svg";